// ABOUTME: Repeat/loop icon for workout repetition indicator
// ABOUTME: Drawn in currentColor — `color` when given, else the icon grey (`text-icon`), so it follows the theme

import { cn } from "@shared/lib/utils"

interface RepeatIconProps {
  className?: string
  size?: number
  color?: string
}

export const RepeatIcon = ({ className = "", size = 16, color }: RepeatIconProps) => (
  <svg
    className={cn("text-icon", className)}
    style={color ? { color } : undefined}
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="m17 2 4 4-4 4" />
    <path d="M3 11v-1a4 4 0 0 1 4-4h14" />
    <path d="m7 22-4-4 4-4" />
    <path d="M21 13v1a4 4 0 0 1-4 4H3" />
  </svg>
)
